'use client';

// eslint-disable-next-line no-restricted-imports
import { usePathname } from 'next/navigation';
import { AppRoutes } from '@/i18n/constants';

const CongratsVideoPreload = () => {
  const pathname = usePathname();

  if (pathname !== AppRoutes.home) {
    return null;
  }

  return (
    <div
      aria-hidden="true"
      style={{ position: 'fixed', left: '-9999px', top: '-9999px', width: '1px', height: '1px', overflow: 'hidden', pointerEvents: 'none' }}
    >
      <video muted playsInline preload="auto">
        <source src="/videos/auth/congratulation-registeration/congrats-registration.webm" type="video/webm" />
        <source src="/videos/auth/congratulation-registeration/congrats-registration-ios.mov" type="video/quicktime" />
      </video>
    </div>
  );
};

export default CongratsVideoPreload;
